
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { IDataDetalharLimiteCredUtilizado } from "../../../../../types/api/geral/detalhar-limite-credito-utilizado"
import { useQuery } from "react-query";
import axiosClient from "../../../../../lib/axios";
import LoadingApiQuery from "../../../../../components/LoadingApiQuery";
import { formatarValorMonetario } from "../../../../../helpers/masks";
import DisplayNotFoundInfo from "../../../../../components/DisplayNotFindInfo";
import { useMemo } from "react";
import tratativaDeDatas from "../../../../../helpers/tratativaDeDatas";
import BtnExportarDados from "../../../../../components/BtnExportarDados";

export default function DialogDetalheCredUtilizado({
    open,
    codigo,
    tipo,
    handleClose
}: DialogDetalheCredUtilizadoProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ['detalhar-limite-credito-utilizado', codigo, tipo],
        queryFn: () => axiosClient.get("/detalhar-limite-credito-utilizado", {
            params: {
                publico_id: `${tipo}${codigo}`, 
            }
        }),
        cacheTime: 0
    });
    const dadoLimiteUtilizado: IDataDetalharLimiteCredUtilizado[] = data?.data || []
    //
    const ocorrencias = dadoLimiteUtilizado.map(item => {return item.ocorrencias})

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll="body"
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle display={'flex'} justifyContent={'space-between'}>
                <Typography variant="h6">Detalhe do limite utilizado</Typography>
                <BtnExportarDados
                    tipoExportacao={['csv', 'pdf']}
                    dadosArray={ocorrencias[0]}
                    fileName="detalhe_limite_utilizado"
                    cabecalhoLabels={[
                        { queryKey: "tipo", label: "Tipo" },
                        { queryKey: "data_emissao", label: "Data emissão" },
                        { queryKey: "data_vencimento", label: "Data vencimento" },
                        { queryKey: "identificador", label: "Identificador" },
                        { queryKey: "valor_original", label: "Valor original" },
                        { queryKey: "valor_atualizado", label: "Valor atualizado" },
                    ]}
                    formatos={{
                        "Data vencimento": "data",
                        "Data emissão": "data",
                    }}
                />
            </DialogTitle>

            <DialogContent>
                {isLoading && <LoadingApiQuery />}

                {
                    !isLoading &&
                    <>
                        {
                            dadoLimiteUtilizado.map((item, index) => (
                                <TableCred key={index} {...item} />
                            ))
                        }
                    </>
                }
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const TableCred = ({
    ocorrencias
}: TableCredProps) => {

    const somatorio = useMemo(() => {
        return ocorrencias.reduce((acc, item) => {
            return {
                valor_original: acc.valor_original + item.valor_original,
                valor_atualizado: acc.valor_atualizado + item.valor_atualizado
            };
        }, { valor_original: 0, valor_atualizado: 0 });
    }, [ocorrencias]);

    return (
        <>
            {
                ocorrencias.length === 0 &&
                <DisplayNotFoundInfo label="Nenhum dado encontrado" />
            }

            {
                ocorrencias.length > 0 &&
                <>
                    <TableContainer
                        sx={{ height: 400, overflow: "auto", pb: 1 }}
                    >
                        <Table
                            stickyHeader
                            sx={{ border: "1px solid #0000001f" }}
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Tipo</b></TableCell>
                                    <TableCell><b>Data emissão</b></TableCell>
                                    <TableCell><b>Data vencimento</b></TableCell>
                                    <TableCell><b>Identificador</b></TableCell>
                                    <TableCell align="right"><b>Valor original</b></TableCell>
                                    <TableCell align="right"><b>Valor atualizado</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {ocorrencias.map((row) => (
                                    <TableRow
                                        key={row.identificador}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.tipo}
                                        </TableCell>
                                        <TableCell>{tratativaDeDatas(row.data_emissao)}</TableCell>
                                        <TableCell>{tratativaDeDatas(row.data_vencimento)}</TableCell>
                                        <TableCell>{row.identificador}</TableCell>
                                        <TableCell align="right">{formatarValorMonetario(row.valor_original)}</TableCell>
                                        <TableCell align="right">{formatarValorMonetario(row.valor_atualizado)}</TableCell>
                                    </TableRow>
                                ))}

                                <TableRow
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 }
                                    }}
                                >
                                    <TableCell colSpan={4}><b>Total</b></TableCell>
                                    <TableCell align="right"><b>{formatarValorMonetario(somatorio.valor_original)}</b></TableCell>
                                    <TableCell align="right"><b>{formatarValorMonetario(somatorio.valor_atualizado)}</b></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }
        </>
    )
}

interface DialogDetalheCredUtilizadoProps {
    open: boolean,
    handleClose: () => void,
    codigo: string,
    tipo: string
}

interface TableCredProps extends IDataDetalharLimiteCredUtilizado { }